import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { DialogService, NotificationService } from '@wms/services';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { replace } from '@wm/core';

@Component({
  selector: 'wms-vcs-pull-dialog',
  templateUrl: './wms-vcs-pull-dialog.component.html',
  styleUrls: ['./wms-vcs-pull-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
  ],
})
export class WmsVcsPullDialogComponent extends BaseComponent {
  @Input() vcsAction:string
  @Input() id: string
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;
  private dialogService: DialogService

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService);
    this.dialogService = inject(DialogService)
  }

  pullProjectChanges(): void {
    this.vcsService.closeDialogWithId('pullChangesModal');
    (this.vcsAPIService.pullChanges() as Promise<any>).then(() => {
      this.notificationService.show(
        'success',
        '',
        this.locale['MESSAGE_VCS_PULL_SUCCESS']
      );
      window.location.reload();
    })
    .catch((errObj)=>{
      let errorObject = errObj.error.errors.error[0],
      errorMessage:any =  replace(errorObject['message'], errorObject['parameters'], true)
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errorMessage);
      if (errorObject.messageKey === 'VCS_AUTHENTICATION_FAILED') {
        this.vcsService.showUserVCSCredentialsDialog('',  errorMessage);
      }
    })
  }

  closeDialog(){
    this.dialogService.close(this.id)
    this.vcsService.vcsAction = ""
  }
}
